import { BooleanDataDefinition } from "../../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { NumberDataDefinition } from "../../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StringDataDefinition } from "../../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataDefinition } from "../../../../rule-engine-core/Common/Data/DataDefinition";

import { getTestInputDataDefinition } from "../../DataDefinition";
import { GreaterThanExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/GreaterThan";
import { SubstractExpression } from "../../../../rule-engine-core/Expressions/Expressions/Math/SubstractExpression";
import { DateGetYearExpression } from "../../../../rule-engine-core/Expressions/Expressions/Date/DateGetYearExpression";
import { DateGetTodayExpression } from "../../../../rule-engine-core/Expressions/Expressions/Date/DateGetTodayExpression";
import { IfThenExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";
import { NotExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/NotExpression";
import { ExistsExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/Exists";
import { StringContainsExpression } from "../../../../rule-engine-core/Expressions/Expressions/String/StringContainsExpression";
import { IsTrueExpression } from "../../../../rule-engine-core/Expressions/Expressions/Logic/IsTrue";
import { ValueRuleCell } from "../../../../rule-engine-core/Rule/Table/Value/Structure/ValueRuleCell";
import { ValueTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Value/ValueTableConfiguration";

export const getValueTableEmpty = (): ValueTableConfiguration => {
    const valueRuleDefinition = new ValueTableConfiguration();
    valueRuleDefinition.inputData = getTestInputDataDefinition();

    return valueRuleDefinition;
};

export const getValueTableExample = (): ValueTableConfiguration => {
    const valueRuleDefinition = new ValueTableConfiguration();
    valueRuleDefinition.inputData = getTestInputDataDefinition();
    valueRuleDefinition.executionResult = new DataDefinition();

    let greaterThan = new GreaterThanExpression();

    let subExp = new SubstractExpression();
    greaterThan.value1.subExpression = subExp;

    let getyearExp = new DateGetYearExpression();

    let getToday = new DateGetTodayExpression();
    getyearExp.value1.subExpression = getToday;

    subExp.value1.subExpression = getyearExp;

    getyearExp = new DateGetYearExpression();
    getyearExp.value1.variableName = "dateOfHire";

    subExp.value2.subExpression = getyearExp;

    greaterThan.value2.variableName = "cellValue";

    valueRuleDefinition.columns[0].expression.expression = greaterThan;

    valueRuleDefinition.setRuleColumnType(valueRuleDefinition.columns[0], new NumberDataDefinition("cellValue"));

    valueRuleDefinition.addColumn();

    let ifThen = new IfThenExpression();

    let notExp = new NotExpression();

    let exists = new ExistsExpression();
    exists.dataPath = "promotionHistory";

    notExp.value1.subExpression = exists;

    ifThen.ifBranches[0].ifExpression!.elements[0].subExpression = notExp;
    ifThen.ifBranches[0].ifExpression!.add();

    exists = new ExistsExpression();
    exists.dataPath = "disciplinaryActionsHistory";
    ifThen.ifBranches[0].ifExpression!.elements[1].subExpression = exists;

    ifThen.trueOutput.variableName = "cellValue";
    ifThen.defaultOutput.variableName = "cellValue";

    valueRuleDefinition.columns[1].expression.expression = ifThen;

    valueRuleDefinition.setRuleColumnType(valueRuleDefinition.columns[1], new BooleanDataDefinition("cellValue"));

    valueRuleDefinition.addColumn();

    ifThen = new IfThenExpression();

    let isTrue = new IsTrueExpression();
    isTrue.value1.variableName = "isManager";

    ifThen.ifBranches[0].ifExpression!.elements[0].subExpression = isTrue;

    ifThen.trueOutput.variableName = "cellValue";
    ifThen.defaultOutput.variableName = "cellValue";

    valueRuleDefinition.columns[2].expression.expression = ifThen;
    valueRuleDefinition.setRuleColumnType(valueRuleDefinition.columns[2], new BooleanDataDefinition("cellValue"));

    valueRuleDefinition.addColumn();

    let containsExp = new StringContainsExpression();

    containsExp.value1.variableName = "salaryBand";
    containsExp.value2.variableName = "cellValue";

    valueRuleDefinition.columns[3].expression.expression = containsExp;

    valueRuleDefinition.addRow();
    valueRuleDefinition.addRow();
    valueRuleDefinition.addRow();
    valueRuleDefinition.addRow();
    valueRuleDefinition.addRow();
    valueRuleDefinition.addRow();
    valueRuleDefinition.addRow();
    valueRuleDefinition.addRow();

    valueRuleDefinition.rows[0].cells[0].values = 2;
    valueRuleDefinition.rows[1].cells[0].values = 2;
    valueRuleDefinition.rows[2].cells[0].values = 2;
    valueRuleDefinition.rows[3].cells[0].values = 2;
    valueRuleDefinition.rows[4].cells[0].values = 2;
    valueRuleDefinition.rows[5].cells[0].values = 2;
    valueRuleDefinition.rows[6].cells[0].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[7].cells[0].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[8].cells[0].values = ValueRuleCell.IGNORE_CELL_VALUE;

    valueRuleDefinition.rows[0].cells[1].values = true;
    valueRuleDefinition.rows[1].cells[1].values = true;
    valueRuleDefinition.rows[2].cells[1].values = true;
    valueRuleDefinition.rows[3].cells[1].values = false;
    valueRuleDefinition.rows[4].cells[1].values = true;
    valueRuleDefinition.rows[5].cells[1].values = false;
    valueRuleDefinition.rows[6].cells[1].values = true;
    valueRuleDefinition.rows[7].cells[1].values = true;
    valueRuleDefinition.rows[8].cells[1].values = false;

    valueRuleDefinition.rows[0].cells[2].values = true;
    valueRuleDefinition.rows[1].cells[2].values = false;
    valueRuleDefinition.rows[2].cells[2].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[3].cells[2].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[4].cells[2].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[5].cells[2].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[6].cells[2].values = true;
    valueRuleDefinition.rows[7].cells[2].values = true;
    valueRuleDefinition.rows[8].cells[2].values = false;

    valueRuleDefinition.rows[0].cells[3].values = "AC";
    valueRuleDefinition.rows[1].cells[3].values = "AC";
    valueRuleDefinition.rows[2].cells[3].values = "AE";
    valueRuleDefinition.rows[3].cells[3].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[4].cells[3].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[5].cells[3].values = ValueRuleCell.IGNORE_CELL_VALUE;
    valueRuleDefinition.rows[6].cells[3].values = "AC";
    valueRuleDefinition.rows[7].cells[3].values = "AC";
    valueRuleDefinition.rows[8].cells[3].values = ValueRuleCell.IGNORE_CELL_VALUE;

    valueRuleDefinition.addResultColumn();

    valueRuleDefinition.rows[0].resultCells[0].value = true;
    valueRuleDefinition.rows[1].resultCells[0].value = false;
    valueRuleDefinition.rows[2].resultCells[0].value = true;
    valueRuleDefinition.rows[3].resultCells[0].value = false;
    valueRuleDefinition.rows[4].resultCells[0].value = true;
    valueRuleDefinition.rows[5].resultCells[0].value = false;
    valueRuleDefinition.rows[6].resultCells[0].value = true;
    valueRuleDefinition.rows[7].resultCells[0].value = false;
    valueRuleDefinition.rows[8].resultCells[0].value = false;

    valueRuleDefinition.rows[0].resultCells[1].value = "Schendule Meeting";
    valueRuleDefinition.rows[1].resultCells[1].value = "Send Survey";
    valueRuleDefinition.rows[2].resultCells[1].value = "Schedule Meeting";
    valueRuleDefinition.rows[3].resultCells[1].value = "Do Nothing";
    valueRuleDefinition.rows[4].resultCells[1].value = "Schedule Meeting";
    valueRuleDefinition.rows[5].resultCells[1].value = "Send Survey";
    valueRuleDefinition.rows[6].resultCells[1].value = "Schedule Meeting";
    valueRuleDefinition.rows[7].resultCells[1].value = "Send Survey";
    valueRuleDefinition.rows[8].resultCells[1].value = "Do Nothing";

    valueRuleDefinition.defaultResult[valueRuleDefinition.resultColumns[0]._id].value = false;
    valueRuleDefinition.defaultResult[valueRuleDefinition.resultColumns[1]._id].value = "Do Nothing";

    valueRuleDefinition.setResultColumnType(
        valueRuleDefinition.resultColumns[0],
        new BooleanDataDefinition("result_1"),
    );

    valueRuleDefinition.setResultColumnType(valueRuleDefinition.resultColumns[1], new StringDataDefinition("result_2"));

    valueRuleDefinition.syncAllRows();

    return valueRuleDefinition;
};
